import { updatePostPayment } from '../../../utils/apis';
import { IPaymentObject } from '../../../utils/types';

export interface PaymentCallbackProps {
  paymentObject: IPaymentObject;
  closePopup: () => void;
  onSuccess?: () => void;
  onError?: (error: any) => void;
}

export const handlePaymentSuccess = async (
  response: any, 
  props: PaymentCallbackProps
) => {
  try {
    console.log('Payment success:', response);

    if(response?.data) {
      response = response?.data;
    }

    // Check if payment was actually successful
    if (!response.isSuccess) {
      console.log('Payment was not successful, treating as error');
      // Call error handler instead
      await handlePaymentError(response, props);
      return;
    }
    
    // Extract payment details from response
    const payabaliResponse = {
      isSuccess: response.isSuccess,
      responseData: response.responseData || response
    };

    console.log('🔍 [DEBUG] payabaliResponse', response, payabaliResponse);
    
    // Extract reference ID handling both nested (wallet) and direct (card/ACH) structures
    const referenceId = response?.responseData?.referenceId || response?.referenceId || '';
    
    const metadata = {
      phoneNumber: props.paymentObject.donationData?.phoneNumber,
      address: props.paymentObject.donationData?.address,
      specialDesignation: props.paymentObject.donationData?.specialDesignation,
    }
    // Call backend API to update payment
    await updatePostPayment(
      props.paymentObject.amount,
      referenceId,
      payabaliResponse,
      props.paymentObject.identityId,
      props.paymentObject.isRecurring,
      props.paymentObject.startDate,
      props.paymentObject.frequency,
      props.paymentObject.paymentType,
      props.paymentObject.donationData?.firstName,
      props.paymentObject.donationData?.lastName,
      props.paymentObject.donationData?.email,
      metadata
    );
    
    // Close popup and trigger success callback
    props.closePopup();
    if (props.onSuccess) {
      props.onSuccess();
    }
    
  } catch (error) {
    console.error('Error updating payment:', error);
    if (props.onError) {
      props.onError(error);
    }
  }
};

export const handlePaymentError = async (
  errors: any, 
  props: PaymentCallbackProps
) => {
  try {
    console.log('Payment error:', errors);
    
    // Extract error details - use the complete response object
    const payabaliResponse = {
      isSuccess: errors.isSuccess || false,
      responseData: errors.responseData || errors
    };
    
    // Extract reference ID handling both nested (wallet) and direct (card/ACH) structures
    const referenceId = errors?.responseData?.referenceId || errors?.referenceId || '';
    
    // Call backend API to update payment with error status
    await updatePostPayment(
      props.paymentObject.amount,
      referenceId,
      payabaliResponse,
      props.paymentObject.identityId,
      props.paymentObject.isRecurring,
      props.paymentObject.startDate,
      props.paymentObject.frequency,
      props.paymentObject.paymentType,
      props.paymentObject.donationData?.firstName,
      props.paymentObject.donationData?.lastName,
      props.paymentObject.donationData?.email
    );
    
    // Trigger error callback
    if (props.onError) {
      props.onError(errors);
    }
    
  } catch (apiError) {
    console.error('Error updating payment on failure:', apiError);
    if (props.onError) {
      props.onError(apiError);
    }
  }
}; 